export default __webpack_public_path__ + "static/media/kal-visuals-Bt_J-VvC9-A-unsplash.9331dfdb.jpg";